import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { API_URL_SUBMIT_INCOMPLETE_ORDER, FORM_ID } from "../../../../../constants";
import { RootState } from "../../../../../models";
import { post as AJAX_post } from "../../../app/Ajax";
import { CHECKOUT_SUBMIT_INCOMPLETE_ORDER_FORM } from "../actionTypes";
import { getFormById } from "../selectors/formSelectors";

interface IncompleteOrderFormFields {
    email: string;
    firstName: string;
    lastName: string;
    phone: string;
}

export const submitIncompleteOrderForm = (): ThunkAction<void, RootState, unknown, AnyAction> => {
    return (dispatch, getState) => {
        const { values } = getFormById(getState(), FORM_ID.INCOMPLETE_ORDER);
        const formData: IncompleteOrderFormFields = values.details;

        return dispatch({
            type: CHECKOUT_SUBMIT_INCOMPLETE_ORDER_FORM,
            payload: AJAX_post(
                {
                    url: API_URL_SUBMIT_INCOMPLETE_ORDER,
                    data: { ...formData },
                },
                dispatch,
            ),
        });
    };
};
